export const onboardingAnswerTypes = {
  SINGLE_CHOICE: "SingleChoice",
  MULTIPLE_CHOICE: "MultipleChoice",
  TEXT_ANSWER: "FreeText",
};
